import '../styles/Picker.css';
import '../styles/ColorPicker.css';

import React, { useState } from 'react';

import Button from '@mui/material/Button';
import { ColorResult } from 'react-color';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { RgbaColor } from '../../content/models/LessonComponentStyle';
import SketchPickerTheme from './SketchPickerTheme';

interface ColorPickerDialogProps {
  color: RgbaColor;
  onClose: (color?: RgbaColor) => void;
}

const ColorPickerDialog = (props: ColorPickerDialogProps) => {
  const [color, setColor] = useState(props.color);

  const handleChangeComplete = (color: ColorResult) => {
    setColor(color.rgb);
  };

  return (
    <Dialog open>
      <DialogContent>
        <SketchPickerTheme
          color={color}
          onChangeComplete={handleChangeComplete}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={(e) => props.onClose()} color="primary">
          Cancel
        </Button>
        <Button
          onClick={() => {
            color ? props.onClose(color) : props.onClose();
          }}
          color="primary"
          autoFocus
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ColorPickerDialog;
